/* Verzekerde bezorging — universal swipe-toggle behavior
   - Always defaults to ON whenever a real product is in the cart
   - Customer can manually toggle OFF (it gets removed from cart)
   - Next cart change (add another product / page reload) re-includes it.
   Event delegation keeps the toggle working through any DOM mutations. */
(function () {
  let busy = false;

  function getInsuredVariantId() {
    const btn = document.querySelector('[data-ist-toggle]');
    return btn ? String(btn.dataset.istVariantId) : null;
  }

  function setState(on) {
    document.querySelectorAll('[data-ist-toggle]').forEach((b) => {
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', String(on));
    });
  }

  function setBusy(yes) {
    document.querySelectorAll('[data-ist-toggle]').forEach((b) => {
      if (yes) b.setAttribute('aria-busy', 'true');
      else b.removeAttribute('aria-busy');
    });
  }

  async function syncFromCart() {
    const variantId = getInsuredVariantId();
    if (!variantId) return null;
    try {
      const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json());
      const inCart = (cart.items || []).some((i) => String(i.variant_id) === String(variantId));
      setState(inCart);
      return cart;
    } catch (_) { return null; }
  }

  async function refreshOtherCartUIs() {
    const atc = document.querySelector('chesto-sticky-atc');
    if (atc && typeof atc._refreshCart === 'function') {
      atc._refreshCart();
    }
    const ccSection = document.querySelector('[data-cc-section]');
    if (ccSection) {
      try {
        const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json());
        const subEl = ccSection.querySelector('[data-cc-subtotal]');
        const totEl = ccSection.querySelector('[data-cc-total]');
        const fmt = (cents) => {
          const e = Math.floor(cents / 100);
          const r = cents % 100;
          return r === 0 ? `€${e},–` : `€${e},${String(r).padStart(2, '0')}`;
        };
        if (subEl) subEl.textContent = fmt(cart.items_subtotal_price);
        if (totEl) totEl.textContent = fmt(cart.total_price);
      } catch (_) {}
    }
    try {
      const r = await fetch('/?sections=cart-drawer,cart-icon-bubble,cart-live-region-text');
      const data = await r.json();
      if (data['cart-drawer']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');
        const oldDrawer = document.querySelector('cart-drawer');
        if (newDrawer && oldDrawer) {
          oldDrawer.innerHTML = newDrawer.innerHTML;
        }
      }
      if (data['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = data['cart-icon-bubble'];
      }
    } catch (_) {}
    document.dispatchEvent(new CustomEvent('chesto:cart:changed', { detail: { source: 'ist' } }));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  async function handleToggle(btn) {
    if (busy) return;
    const variantId = btn.dataset.istVariantId;
    if (!variantId) return;
    busy = true;
    setBusy(true);
    const isOn = btn.classList.contains('is-on');
    try {
      if (!isOn) {
        const fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        await fetch('/cart/add.js', { method: 'POST', body: fd });
      } else {
        const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json());
        const line = (cart.items || []).find((i) => String(i.variant_id) === String(variantId));
        if (line) {
          const updates = {};
          updates[line.key] = 0;
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates })
          });
        }
      }
      setState(!isOn);
      await refreshOtherCartUIs();
      await syncFromCart();
    } catch (err) {
      console.error('[insured-toggle] failed:', err);
      await syncFromCart();
    } finally {
      setBusy(false);
      busy = false;
    }
  }

  // Event delegation — survives DOM replacements
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleToggle(btn);
  });

  async function autoIncludeInsured() {
    const variantId = getInsuredVariantId();
    if (!variantId) return;
    if (busy) return;
    try {
      const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json());
      const items = cart.items || [];
      const hasReal = items.some((i) => String(i.variant_id) !== String(variantId));
      const hasInsured = items.some((i) => String(i.variant_id) === String(variantId));
      if (!hasReal && !hasInsured) {
        setState(false);
        return;
      }
      // Real product present but insured missing → auto-add (always start ON)
      if (hasReal && !hasInsured) {
        const fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        await fetch('/cart/add.js', { method: 'POST', body: fd });
        await refreshOtherCartUIs();
        setState(true);
      } else {
        setState(hasInsured);
      }
    } catch (_) {}
  }

  function bootstrap() {
    syncFromCart();
    autoIncludeInsured();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-sync after cart changes. Skip auto-include on our own events (so a
  // manual toggle-off doesn't immediately get re-added).
  document.addEventListener('cart:added', () => setTimeout(() => { syncFromCart(); autoIncludeInsured(); }, 80));
  document.addEventListener('cart:refresh', () => setTimeout(syncFromCart, 80));
  document.addEventListener('chesto:cart:changed', (e) => {
    const src = e && e.detail && e.detail.source;
    setTimeout(() => {
      syncFromCart();
      if (src !== 'ist' && src !== 'auto-insured') autoIncludeInsured();
    }, 80);
  });
})();
